// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"1502":"ricos-viewer","3262":"UpgradeModal","4081":"Ricos","4614":"Status","4681":"Checkout","7203":"Widget","8510":"Restricted","8631":"AdditionalInfoStep-AdditionalInfoStep"}[chunkId] || chunkId) + ".chunk.min.css";
};